import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Join class names, with later Tailwind utilities beating earlier ones.
 *
 * `clsx` alone would emit `p-2 p-4` and leave the winner to CSS source order —
 * which is not the order they were written in, so a caller's override silently
 * loses. `twMerge` resolves the conflict the way the caller expects: the last
 * one wins.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
